import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { isMobile } from "react-device-detect"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Video from "../elements/Video"
import Tags from "../elements/Tags"

import event_1 from "../../images/events/november/event-6.mp4"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". event-3 event-3 event-3" ". . culture-1 culture-1" "culture-2 culture-2 . ." ". . culture-3 culture-3" "culture-4 culture-4 . .";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .event-3 {
    grid-area: event-3;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  .culture-3 {
    grid-area: culture-3;
  }
  .culture-4 {
    grid-area: culture-4;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto auto auto;
    /* grid-template-areas: ". event-1 event-1 ." ". . event-2 event-2" "event-3 event-3 event-2 event-2 " "event-3 event-3 . ." ". . culture-1 ." ". culture-2 culture-1 ." ". culture-2 culture-3 ." ". culture-4 culture-3" ". culture-4 . ."; */
    grid-template-areas: ". event-1 event-1 ." ". . event-2 event-2" "event-3 event-3 event-2 event-2 " "event-3 event-3 . ." ". . culture-1 ." ". culture-2 culture-1 ." ". culture-2 culture-3 ." ". . culture-3 culture-4" ". . . culture-4";
  }
  @media (min-width: 1200px) {
  }
`

const November = () => {
  const data = useStaticQuery(graphql`
    query {
      novemberEventOneFB: file(
        relativePath: { eq: "events/november/event-1-fb.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      novemberEventTwo: file(
        relativePath: { eq: "events/november/event-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      novemberEventThree: file(
        relativePath: { eq: "events/november/event-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1500, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      novemberCultureOne: file(
        relativePath: { eq: "events/november/culture-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      novemberCultureTwo: file(
        relativePath: { eq: "events/november/culture-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      novemberCultureThree: file(
        relativePath: { eq: "events/november/culture-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      novemberCultureFour: file(
        relativePath: { eq: "events/november/culture-4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="november">
      <Grid>
        <Block className="event-1">
          {isMobile ? (
            <Photo
              img={data.novemberEventOneFB}
              maxWidth={800}
              maxHeight={600}
            />
          ) : (
            <Video src={event_1} width={720} height={720} />
          )}
          <h4 style={{ maxWidth: 800 }}>
            “Smart City” is more than a buzzword. We’re actually building one.
            The new{" "}
            <a
              href="https://www.menlynmaine.co.za/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Menlyn Maine
            </a>{" "}
            tenant interface shows realtime water and electricity stats, reports
            issues and faults, manages guest access, and even knows when the
            next load shedding downer will happen. Smart, right?
          </h4>
          <Tags
            maxWidth={400}
            words={[
              "react",
              "gatsbyjs",
              "graphql",
              "serverless",
              "python",
              "postgresql",
            ]}
          />
        </Block>

        <Block className="event-2">
          <Photo img={data.novemberEventTwo} maxWidth={800} maxHeight={600} />
          <h4 style={{ maxWidth: 800 }}>
            Using Google Firebase and AWS Rekognition we’ve automated the KYC
            and on boarding for new tenants at Menlyn Maine.
          </h4>
        </Block>

        <Block className="event-3">
          <Photo
            img={data.novemberEventThree}
            maxWidth={1500}
            maxHeight={800}
          />
          <h4 style={{ maxWidth: 1500 }}>
            Teamgeek got to join forces with the smart nerds at{" "}
            <a
              href="https://ranktank.net/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              RankTank
            </a>{" "}
            to improve their leading Google keyword rank checking tool.
          </h4>
          <Tags
            maxWidth={400}
            words={["gcp", "firebase", "googlesheets", "typescript", "openapi"]}
          />
        </Block>

        <Block className="culture-1">
          <Photo img={data.novemberCultureOne} maxWidth={600} maxHeight={600} />
          <h4 style={{ maxWidth: 600 }}>
            End-of-year shenanigans with all the Geeks.
          </h4>
        </Block>

        <Block className="culture-2">
          <Photo img={data.novemberCultureTwo} maxWidth={600} maxHeight={600} />
          <h4 style={{ maxWidth: 600 }}>
            The Annual Beer Pong Champs ended in tears for most, but not for
            Eduan and Ryan 🤑
          </h4>
        </Block>
        <Block className="culture-3">
          <Photo
            img={data.novemberCultureThree}
            maxWidth={400}
            maxHeight={522}
          />
          <h4 style={{ maxWidth: 400 }}>
            Simon celebrated his birthday in style…
          </h4>
        </Block>

        <Block className="culture-4">
          <Photo
            img={data.novemberCultureFour}
            maxWidth={400}
            maxHeight={522}
          />
          <h4 style={{ maxWidth: 400 }}>With none other than Gerhard 🤙</h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default November
